import { SERVER_URL } from "../utils/constants";

const updateUserData = async (user) => {
  const response = await fetch(`${SERVER_URL}/updateUserData`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user }),
  });
  if (response.status !== 200) {
    // response contains { error: "error message" }
    const error = await response.json();
    throw new Error(error.error);
  }
  return await response.json();
};

export default updateUserData;
